var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-dropdown',{attrs:{"label":_vm.label || _vm.$t('selections.select'),"items":_vm.listItems,"hiddenField":_vm.hiddenField,"isRequired":_vm.isRequired,"disabled":_vm.disabled,"dropdownId":'rdbLookupDropdown'},on:{"input":_vm.onChange},model:{value:(_vm.selectedValue),callback:function ($$v) {_vm.selectedValue=$$v},expression:"selectedValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }